import React from 'react';
import PropTypes from 'prop-types';
import './ScrollRegion.scss';

/**
 * Flex child that scrolls vertically (`min-height: 0`, overflow-y auto).
 * Max height defaults to `--ds-scroll-region-max-height` (see foundations).
 */
const ScrollRegion = ({ children, className = '', maxHeight, style, ...rest }) => {
  const mergedStyle = { ...(style || {}) };
  if (maxHeight != null && maxHeight !== '') {
    mergedStyle.maxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
  }
  const hasStyle = Object.keys(mergedStyle).length > 0;

  return (
    <div
      className={['ds-scroll-region', className].filter(Boolean).join(' ')}
      style={hasStyle ? mergedStyle : undefined}
      {...rest}
    >
      {children}
    </div>
  );
};

ScrollRegion.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.shape({}),
};

ScrollRegion.defaultProps = {
  children: undefined,
  className: '',
  maxHeight: undefined,
  style: undefined,
};

export default ScrollRegion;
